import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalFormComponent } from '@shared/components/modal/modal-form/modal-form.component';
import { ChipsListLegacyComponent } from '@shared/components/chips-legacy/chips-legacy.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { BottomTableComponent } from '@shared/components/bottom-table/bottom-table.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatPaginatorModule } from '@angular/material/paginator';
import { InputSelectComponent } from './form/input-select/input-select.component';
import { InputTextComponent } from './form/input-text/input-text.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TableContentComponent } from '@shared/components/table-content/table-content.component';
import { InputSearchComponent } from '@shared/components/input-search/input-search.component';
import { InputListBoxComponent } from './input-list-box/input-list-box.component';
import { FilterTableComponent } from '@shared/components/filter-table/filter-table.component';
import { DirectiveModule } from '@directives/directive.module';
import { InputSelectMultipleComponent } from './form/input-select-multiple/input-select-multiple.component';
import * as ImageComponents from './image';
import { MultipleSelectChipComponent } from './multiple-select-chip/multiple-select-chip.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SliderComponent } from './slider/slider.component';
import { MatSliderModule } from '@angular/material/slider';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { NoteViewComponent } from './note-view/note-view.component';
import { CustomsSnackbarComponent } from './customs-snackbar/customs-snackbar.component';
import { InputSelect2Component } from './form/input-select2/input-select2.component';
import { Select2Module } from 'ng-select2-component';
import { InputMultipleChipsComponent } from './form/input-multiple-chips/input-multiple-chips.component';
import { InputSelectMaterialComponent } from './form/input-select-material/input-select-material.component';
import { MatInputModule } from '@angular/material/input';
import { SwiperModule } from 'swiper/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InputAutocompleteComponent } from './form/input-autocomplete/input-autocomplete.component';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NoteViewWithDetailComponent } from './note-view/note-view-with-detail/note-view-with-detail.component';
import { MaiTabGroupComponent } from '@shared/components/mai-tab-group/mai-tab-group.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MaiTabComponent } from '@shared/components/mai-tab/mai-tab.component';
import { InputCounterOrderComponent } from '@shared/components/form/input-counter-order/input-counter-order.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ModalDetailWithImageComponent } from './modal/modal-detail-with-image/modal-detail-with-image.component';
import { InputCounterComponent } from '@shared/components/input-counter/input-counter.component';
import { ModalDetailWithDocumentComponent } from './modal/modal-detail-with-document/modal-detail-with-document.component';
import { InputCounterNumberComponent } from '@shared/components/form/input-counter-number/input-counter-number.component';
import { ModalResponseComponent } from './modal/modal-response/modal-response.component';
import { TextCopyClipboardComponent } from './text-copy-clipboard/text-copy-clipboard.component';
import { CardHeaderSpmComponent } from '@pages/spm/components/card-header-spm/card-header-spm.component';
import { ModalDetailPromagComponent } from './modal-detail-promag/modal-detail-promag.component';
import { ModalStaticCancelComponent } from './modal/modal-static-cancel/modal-static-cancel.component';
import { TableListLoaderComponent } from '@shared/components/loader';
import { InputSelectScopeComponent } from './input-select-scope/input-select-scope.component';
import { InputSelectAutocompleteComponent } from '@shared/components/v1/input/input-select-autocomplete/input-select-autocomplete.component';
import { InputSelectScopeRoleComponent } from './input-select-scope-role/input-select-scope-role.component';
import { ChipsComponent } from '@shared/components/v1/chips/chips.component';
import { InputSelectRadioComponent } from '@shared/components/v1/input/input-select-radio/input-select-radio.component';
import { MatRadioModule } from '@angular/material/radio';
import { SectionVerifiedBadgeComponent } from '@shared/components/section-verified-badge/section-verified-badge.component';
import { ButtonGroupVerifyComponent } from '@shared/components/button-group-verify/button-group-verify.component';
import { InputRevisionNoteLegacyComponent } from '@shared/components/input-revision-note-legacy/input-revision-note-legacy.component';
import { ImageUploadCropperComponent } from '@shared/components/image';
import { InputDatePickerComponent } from './v1/input/input-date-picker/input-date-picker.component';
import { DocumentPreviewComponent } from './document-preview/document-preview.component';
import { DocumentUploadComponent } from '@shared/components/document-upload/document-upload.component';
import { ModalProgressScanRetailerComponent } from './modal/modal-progress-scan-retailer/modal-progress-scan-retailer.component';
import { InputListBoxWithAreaComponent } from './form/input-list-box-with-area/input-list-box-with-area.component';
import { ModalNonActiveCustomerComponent } from './modal/modal-non-active-customer/modal-non-active-customer.component';
import * as CardComponents from './card';
import * as LoaderComponents from './loader';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ImagePreviewComponent } from './image';

const CARD_COMPONENTS = [
  CardComponents.CardLogLegacyComponent,
  CardComponents.CardProfileHeaderComponent,
  CardComponents.CardRejectReasonComponent,
  CardComponents.CardProductPromagComponent,
  CardComponents.CardProductOrderComponent,
  CardComponents.CardProductOrderListComponent,
  CardComponents.CardNotifExpiredComponent,
  CardComponents.CardDocumentComponent,
  CardComponents.CardDetailBodyComponent,
  CardComponents.CardPriceSummaryComponent,
  CardComponents.CardProductNeedFullFillComponent,
  CardComponents.CardHeaderSectionComponent,
  CardComponents.CardHeaderInformationComponent,
  CardComponents.CardHeaderLoaderComponent,
  CardComponents.CardHeaderCounterComponent,
  CardComponents.CardPriceSummaryV1Component,
  CardComponents.CardSummaryInfoComponent,
  // convert to standalone
  // CardComponents.CardComponent,
  // CardComponents.CardEmptyComponent,
  // CardComponents.CardLogComponent,
];

const IMAGE_COMPONENTS = [
  ImageComponents.ImageComponent,
  ImageComponents.ImageUploadComponent,
  ImageComponents.ImageUploadCropperComponent,
  ImageComponents.MultipleImageUploadComponent,
];

const LOADER_COMPONENTS = [
  LoaderComponents.TableListLoaderComponent,
  LoaderComponents.InputListboxLoaderComponent,
  LoaderComponents.SkeletonCardChecklistComponent,
  LoaderComponents.SkeletonTextComponent,
];

@NgModule({
  declarations: [
    ...CARD_COMPONENTS,
    ...IMAGE_COMPONENTS,
    ...LOADER_COMPONENTS,
    FilterTableComponent,
    ChipsListLegacyComponent,
    InputSelectComponent,
    InputSearchComponent,
    InputListBoxComponent,
    InputSelectMultipleComponent,
    MultipleSelectChipComponent,
    DateRangePickerComponent,
    SliderComponent,
    ProgressBarComponent,
    CustomsSnackbarComponent,
    InputSelect2Component,
    InputMultipleChipsComponent,
    InputAutocompleteComponent,
    InputCounterNumberComponent,
    NoteViewWithDetailComponent,
    MaiTabGroupComponent,
    MaiTabComponent,
    InputCounterOrderComponent,
    ModalDetailWithImageComponent,
    InputCounterComponent,
    ModalDetailWithDocumentComponent,
    ModalResponseComponent,
    TextCopyClipboardComponent,
    CardHeaderSpmComponent,
    ModalDetailPromagComponent,
    TableListLoaderComponent,
    InputSelectScopeComponent,
    InputSelectAutocompleteComponent,
    InputSelectScopeRoleComponent,
    InputSelectRadioComponent,
    InputRevisionNoteLegacyComponent,
    ModalStaticCancelComponent,
    ImageUploadCropperComponent,
    InputDatePickerComponent,
    DocumentUploadComponent,
    ModalProgressScanRetailerComponent,
    InputListBoxWithAreaComponent,
    ModalNonActiveCustomerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InlineSVGModule,
    MatPaginatorModule,
    MatSelectModule,
    NgxSkeletonLoaderModule,
    DirectiveModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSliderModule,
    Select2Module,
    MatProgressSpinnerModule,
    MatInputModule,
    SwiperModule,
    DragDropModule,
    RouterModule,
    MatTableModule,
    MatIconModule,
    NgbPopoverModule,
    MatTabsModule,
    MatButtonModule,
    MatCheckboxModule,
    NgOptimizedImage,
    MatRippleModule,
    MatRadioModule,
    ImageCropperModule,
    ModalFormComponent,
    ChipsComponent,
    BottomTableComponent,
    TableContentComponent,
    CardComponents.CardComponent,
    CardComponents.CardEmptyComponent,
    CardComponents.CardLogComponent,
    LoaderComponents.SectionLoaderComponent,
    LoaderComponents.FullscreenLoaderComponent,
    ButtonGroupVerifyComponent,
    SectionVerifiedBadgeComponent,
    ImagePreviewComponent,
    DocumentPreviewComponent,
    ModalComponent,
    InputTextComponent,
    NoteViewComponent,
    InputSelectMaterialComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DirectiveModule,
    InlineSVGModule,
    ImageCropperModule,
    ...CARD_COMPONENTS,
    ...IMAGE_COMPONENTS,
    ...LOADER_COMPONENTS,
    TableContentComponent,
    BottomTableComponent,
    FilterTableComponent,
    ChipsListLegacyComponent,
    ChipsComponent,
    ModalComponent,
    ModalFormComponent,
    InputTextComponent,
    InputSelectComponent,
    InputSelect2Component,
    InputSearchComponent,
    InputListBoxComponent,
    NgxSkeletonLoaderModule,
    InputSelectMultipleComponent,
    MultipleSelectChipComponent,
    DateRangePickerComponent,
    SliderComponent,
    ProgressBarComponent,
    NoteViewComponent,
    InputMultipleChipsComponent,
    InputSelectMaterialComponent,
    InputAutocompleteComponent,
    InputCounterNumberComponent,
    NoteViewWithDetailComponent,
    MaiTabGroupComponent,
    MaiTabComponent,
    InputCounterOrderComponent,
    ModalDetailWithImageComponent,
    InputCounterComponent,
    ModalDetailWithDocumentComponent,
    ModalResponseComponent,
    TextCopyClipboardComponent,
    CardHeaderSpmComponent,
    ModalDetailPromagComponent,
    TableListLoaderComponent,
    InputSelectScopeComponent,
    InputSelectAutocompleteComponent,
    InputSelectScopeRoleComponent,
    InputSelectRadioComponent,
    SectionVerifiedBadgeComponent,
    ButtonGroupVerifyComponent,
    InputRevisionNoteLegacyComponent,
    ModalStaticCancelComponent,
    ImageUploadCropperComponent,
    InputDatePickerComponent,
    DocumentUploadComponent,
    ModalProgressScanRetailerComponent,
    InputListBoxWithAreaComponent,
    ModalNonActiveCustomerComponent,
    // backward compatibility
    CardComponents.CardComponent,
    CardComponents.CardEmptyComponent,
    CardComponents.CardLogComponent,
    LoaderComponents.SectionLoaderComponent,
    LoaderComponents.FullscreenLoaderComponent,
    ButtonGroupVerifyComponent,
    SectionVerifiedBadgeComponent,
    ImagePreviewComponent,
    DocumentPreviewComponent,
  ],
})
export class ComponentsModule {}
